import { SocialLinksEnum } from '@systemeio/digital-store-shared'
import { TLocoType } from 'shared/hooks/use-loco-translation'

export const SCHEME = 'https://'

export const MEDIA_AT_SIGN = '@'

export const MEDIA_WHATSAPP = 'wa.me'

export const getSocialLinkLabel = (t: TLocoType, socialLink: SocialLinksEnum) => {
  switch (socialLink) {
    case SocialLinksEnum.instagram:
    case SocialLinksEnum.tiktok:
    case SocialLinksEnum.twitter:
    case SocialLinksEnum.telegram:
      return MEDIA_AT_SIGN
    case SocialLinksEnum.email:
      return t('global.email')
    case SocialLinksEnum.whatsapp:
      return MEDIA_WHATSAPP
    default:
      return SCHEME
  }
}
